import React, { useEffect } from "react";

export default function BookingContextMenu({
  menu,
  onClose,
  onAction,
}) {
  useEffect(() => {
    if (!menu) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    const handleOutsideClick = () => {
      onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [menu, onClose]);

  if (!menu) return null;

  const stay = menu.stay;

  const actions = [
  ["Tenant Details", "tenant"],
  ["Update Stay Details", "dates"],
  ["Transfer Room", "move"],

 

  ["Cancel Stay", "cancel"],
];

  return (
    <div
      className="occ-context-menu"
      style={{
        left: menu.x,
        top: menu.y,
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <div className="occ-context-caption">
        {stay.tenantName || "Tenant"}
      </div>

      {actions.map(([label, action]) => (
        <button
          key={action}
          type="button"
          className={action === "cancel" ? "danger" : ""}
          onClick={() => {
            onAction(action, stay);
            onClose();
          }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}